module.exports = __webpack_public_path__ + "img/wrong_white.0f32c363.svg";